module.exports = __webpack_public_path__ + "img/How-to-get-the-most-out-of-referencing-with-Dropsmart.77728852.png";